import { Directive, AfterContentInit, Input, ElementRef } from '@angular/core';

@Directive({
  selector: '[wlAutoFocus]',
  standalone: false,
})
export class AutoFocusDirective implements AfterContentInit {
  @Input() wlAutoFocus: boolean;

  constructor(private ref: ElementRef) {}

  ngAfterContentInit() {
    setTimeout(() => {
      this.ref.nativeElement.focus();
    }, 500);
  }
}
